<template>
  <Section
    @back="$emit('back')"
    title="タグ設定"
    margin
    tip-message="タグ設定に戻る"
  >
    <template>
      <v-subheader>リターゲティングタグ設定</v-subheader>
      <v-layout pl-2>
        <v-flex xs3>
          <v-subheader>タグ名称</v-subheader>
        </v-flex>
        <v-flex xs2>
          <v-subheader>保持期間</v-subheader>
        </v-flex>
      </v-layout>
      <v-layout v-for="(tag, index) in menuSetting.tags" :key="index" pl-4>
        <v-flex xs3 pl-2>
          {{ tag.name }}
        </v-flex>
        <v-flex xs2 pl-2> {{ tag.ttlDay }}日 </v-flex>
      </v-layout>
    </template>
    <template v-if="menuSetting.email !== ''">
      <v-subheader>タグ送付先メールアドレス（任意）</v-subheader>
      <v-layout pl-4>
        <v-flex xs3>
          {{ menuSetting.email }}
        </v-flex>
      </v-layout>
    </template>
    <template v-if="menuSetting.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'

export default {
  name: 'CampaignModalPageConfirmRetargetingTarget',
  components: {
    Section,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
  },
}
</script>
